import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import React from 'react';
import { COLOR } from '../../../theme/constants';
import { SearchBarContainer, SearchTextInput } from './SearchBar.styled';

export interface ISearchBar {
   defaultText?: string;
   onChange: any;
   setFocus?: any;
   icon?: FontAwesomeIconProps['icon'];
   showIcon?: boolean;
   className?: string;
}

const SearchBar: React.FC<ISearchBar> = props => {
   const { icon = faSearch, defaultText = '', onChange, setFocus, showIcon = false, className } = props;
   const [searchTerm, setSearchTerm] = React.useState(defaultText);
   const [focused, setFocused] = React.useState(false);

   const handleChange = value => {
      setSearchTerm(value);
      if (onChange) onChange(value);
   };

   const handleFocus = (isFocused: boolean) => {
      setFocused(isFocused);
      if (setFocus) setFocus(isFocused);
   };

   return (
      <SearchBarContainer flexDirection='row' justifyContent='start' spaceBetween={6} active={focused || (searchTerm && searchTerm.length > 0)}>
         {showIcon && <FontAwesomeIcon width={16} color={COLOR.BLUE} icon={icon} />}
         <SearchTextInput value={searchTerm} onChange={handleChange} setFocus={handleFocus} placeholder='Search' />
         {searchTerm.length > 0 && (
            <FontAwesomeIcon
               width={12}
               color={COLOR.GREY_BORDER}
               icon={faTimes}
               cursor='pointer'
               onClick={e => {
                  e.stopPropagation();
                  setSearchTerm('');
                  onChange('');
               }}
            />
         )}
      </SearchBarContainer>
   );
};

export default SearchBar;
